// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adblock__head.adsticky {\n  position: fixed;\n  width: 100%;\n  z-index: 100;\n  padding: 5px 30px;\n}\n\n.adsticky .adblock__title {\n  font-size: 18px;\n}\n\n.adblock__body.adsticky {\n  padding-top: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
